import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectActualsType = createSelector(
  [selectConfigurationState],
  (state) => state.actualsType
)
